import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "material-ui/styles";
import Wrapper from '../common/Wrapper';
import Loader from '../Parts/Loader';

const triple = 3;
const styles = theme => ({
  root: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },

  content: {
    padding: theme.spacing.unit * triple,
    overflowY: 'initial',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'start',
    width: '80%',
  },
});

class ProxyLoginUser extends React.Component {
  componentWillMount() {
    this.props.getProxyLoginUser(this.props.match.params.id, this.props.match.params.token);
  }

  renderBody = () => {
    const { classes } = this.props;

    if (this.props.isProxyLoginLoading || !this.props.user) {
      return (
        <Loader type='color' />
      )
    } else {
      return (
        <div className={classes.content}>
        </div>
      )
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Wrapper className={classes.root}>
        {this.renderBody()}
      </Wrapper>
    );
  }
}

ProxyLoginUser.propTypes = {
  classes: PropTypes.object.isRequired,
  getProxyLoginUser: PropTypes.func.isRequired,
  isProxyLoginLoading: PropTypes.bool,
  user: PropTypes.object,
  match: PropTypes.object,
};

export default withStyles(styles)(ProxyLoginUser);



// WEBPACK FOOTER //
// ./src/components/ProxyLoginUser/ProxyLoginUser.jsx